const NAMESPACE = 'Geofence';
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};


Greenmile.Checks.EventCheck[NAMESPACE] = {

  template() {
    return {
      tag: 'div',
      items: [
        {
          items: [
            {
              items: [
                {
                  attributes: {
                    'id': 'geofence_list',
                    class: 'modelAttribute mandatory',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
            {
              items: [
                {
                  items: [
                    {
                      'tag': 'input',
                      attributes: {
                        "type": 'radio',
                        "name": 'inOut',
                        "id": 'check_geofence_in',
                        "class": 'modelAttribute radioField mandatory',
                        "checked": 'true',
                      },
                    },
                    {
                      tag: 'label',
                      'items': [
                        {
                          "tag": 'span',
                          "html": Monet.I18n.getResourcesByKey('event.geofence.in'),
                          "attributes": {
                            "class": 'i18nResource',
                          },
                        },
                      ],
                      'attributes': {
                        "for": 'check_geofence_in',
                        "style": 'display: inline;',
                      },
                    },
                  ],
                  attributes: {
                    class: 'controls',
                    style: 'display: inline;',
                  },
                },
              ],
              attributes: {
                class: 'control-group',
              },
            },
            {
              items: [
                {
                  items: [
                    {
                      'tag': 'input',
                      'attributes': {
                        "type": 'radio',
                        "name": 'inOut',
                        "id": 'check_geofence_leaving',
                        "class": 'modelAttribute radioField mandatory',
                      },
                    },
                    {
                      tag: 'label',
                      items: [
                        {
                          "tag": 'span',
                          "html": Monet.I18n.getResourcesByKey('event.geofence.out'),
                          "attributes": {
                            "class": 'i18nResource',
                          },
                        },
                      ],
                      attributes: {
                        "for": 'check_geofence_leaving',
                        "style": 'display: inline;',
                      },
                    },
                  ],
                  attributes: {
                    'class': 'controls',
                    'style': 'display: inline;',
                  },
                },
              ],
              attributes: {
                class: 'control-group',
              },
            },
            {
              items: [
                {
                  items: [
                    {
                      tag: 'input',
                      attributes: {
                        "type": 'radio',
                        "name": 'inOut',
                        "id": 'check_geofence_out',
                        "class": 'modelAttribute radioField mandatory',
                      },
                    },
                    {
                      tag: 'label',
                      'items': [
                        {
                          "tag": 'span',
                          "html": Monet.I18n.getResourcesByKey('event.geofence.alreadyout'),
                          "attributes": {
                            "class": 'i18nResource',
                          },
                        },
                      ],
                      attributes: {
                        "for": 'check_geofence_out',
                        "style": 'display: inline;',
                      },
                    },
                  ],
                  attributes: {
                    'class': 'controls',
                    'style': 'display: inline;',
                  },
                },
              ],
              attributes: {
                class: 'control-group',
              },
            },
          ],
          attributes: {
            class: 'control-group',
          },
        },
        {
          tag: 'input',
          attributes: {
            type:'hidden',
            name: 'namespace',
            value: NAMESPACE
          }
        }
      ],
    };
  },

  assignParameter(jsonParam) {
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
    }

    const lookupListGeofence = new Monet.UI.Fields.PowerLookupList();
    lookupListGeofence.setId('geofenceLabel');
    lookupListGeofence.setNameSpace('EventLookupGeofence');
    lookupListGeofence.setMandatory(true);
    lookupListGeofence.setLookUpEntity('Geofence');
    lookupListGeofence.setDisplayKey('description');
    lookupListGeofence.createBaseStructure();
    lookupListGeofence.label.id = 'usersLabel';
    const labelText = Monet.I18n.getResourcesByKey('geofence.description');
    lookupListGeofence.setTextLabel(labelText);

    const content = document.querySelector('#Event #geofence_list');
    content.appendChild(lookupListGeofence.render());

    const body = function () {
      const bodyPost = {
        criteriaChain: [
          {
            or: [],
          },
        ],
      };

      if (jsonParam && jsonParam.geofenceIds) {
        for (let i = 0; i < jsonParam.geofenceIds.length; i++) {
          const geofenceEl = jsonParam.geofenceIds[i];
          bodyPost.criteriaChain[0].or.push({ attr: 'id', eq: geofenceEl });
        }
      }

      return JSON.stringify(bodyPost);
    };

    const checkInOrOut = function () {
      let check = document.querySelector('#check_geofence_in');
      if (jsonParam) {
        const type = jsonParam.geofenceType;

        if (type) {
          check = document.querySelector(`#check_geofence_${type.toLowerCase()} `);
        }
      }
      if (check) {
        check.checked = true;
      }
    };

    checkInOrOut();

    if (jsonParam && jsonParam.geofenceIds) {
      const ajax = new Monet.Ajax();
      ajax.url = 'Geofence/restrictions?criteria={"filters":["id","description"]}';
      ajax.data = body();
      ajax.method = 'POST';
      ajax.success = function (data) {
        if (data) {
          App.Forms.EventLookupGeofence.lookupElement.setValue(data);
        }
      };

      ajax.error = function (xhr) {
        Monet.Configurations.errorNotification(null, xhr, null, null);
      };

      ajax.send();
    }
  },

  retrieveParameter() {
    const data = {};
    let selectedCheck = null;
    const values = App.Forms.EventLookupGeofence.lookupElement.getValue();
    const checks = document.getElementsByClassName('radioField');

    data.geofenceIds = [];
    for (let j = 0; j < values.length; j++) {
      data.geofenceIds.push(parseInt(values[j].id));
    }

    for (let i = 0; i < checks.length; i++) {
      if (checks[i].checked) {
        selectedCheck = checks[i];
      }
    }

    data.geofenceType = selectedCheck.id.replace('check_geofence_', '').toUpperCase();

    return JSON.stringify(data);
  },

  validateParameter(validation) {
    const containerList = document.getElementById('geofence_list');
    if (containerList) {
      const values = App.Forms.EventLookupGeofence.lookupElement.getValue();
      $("#geofence_list .lookupList").addClass('error');

      if (!values || !values.length) {
        validation.errorMessages.push(
          Monet.Form.Messages.mountErrorMessageObject('Greenmile.Event.noGeofenceSelected')
        );
        validation.status = false;
      }
      else {
        $("#geofence_list .lookupList").removeClass('error');
      }
    }
  }
};
